import React from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../../../components";

const ViewSsn = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        password: "",
      },
      {
        password: { type: "text", required: true },
      }
    );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };
  return (
    <Modal
      title={"ENTER PASSWORD"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-2xl"
    >
      <div className="grid  mt-4 gap-x-6 gap-y-4 ">
        <FormFieldSet
          type="text"
          title={"Logged in as: abhi@tektreeinc.com"}
          placeholder="Please Enter Password"
          value={formData.password}
          onChange={(value) => handleChange("password", value)}
          error={errors.password}
        />
      </div>

      <div className="flex gap-3 justify-end my-8">
        <Button title="Cancel" variant="outlined" onClick={onClose} />
        <Button title={"OK"} onClick={() => handleSave()} />
      </div>
    </Modal>
  );
};

export default ViewSsn;
